/**
 * Helper function to verify if the provided latitude and longitude are valid numbers.
 * @param longitude - The longitude to verify.
 * @param latitude - The latitude to verify.
 * @returns {boolean} - Returns true if both latitude and longitude are valid, otherwise false.
 */
export const isLongLatValid = (
  longitude: number | undefined,
  latitude: number | undefined,
): boolean => {
  if (!longitude || !latitude) return false;
  const isLongitudeValid = longitude >= -180 && longitude <= 180;
  const isLatitudeValid = latitude >= -90 && latitude <= 90;
  return isLatitudeValid && isLongitudeValid;
};
